module.exports = __webpack_public_path__ + "img/Lift.ceda93b0.svg";